var trim = require('../string/virtual/trim');

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.trim;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.trim) ? trim : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/trim.js
// module id = 995
// module chunks = 0